import { Link } from 'react-router-dom';
import { getLatestArticles } from '@/mocks/articles';

export default function LatestArticles() {
  const latestArticles = getLatestArticles(4);

  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-8">
        <div>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-1">
            最新资讯
          </h2>
          <p className="text-sm text-foreground-500">
            影视动态、行业资讯一手掌握
          </p>
        </div>
        <Link
          to="/article/a001"
          className="text-sm text-primary-500 hover:text-primary-600 font-medium flex items-center gap-1 whitespace-nowrap transition-colors"
        >
          全部文章 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {latestArticles.map((article) => (
          <Link
            key={article.id}
            to={`/article/${article.id}`}
            className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-primary-200 transition-all"
          >
            <div className="aspect-[16/10] overflow-hidden">
              <img
                src={article.cover}
                alt={article.title}
                title={article.title}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                loading="lazy"
              />
            </div>
            <div className="p-3 md:p-4">
              <span className="inline-block text-xs text-primary-500 bg-primary-50 px-2 py-0.5 rounded mb-2">
                {article.category}
              </span>
              <h3 className="font-medium text-sm md:text-base text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors line-clamp-2">
                {article.title}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-3">
                {article.excerpt}
              </p>
              <div className="flex items-center gap-3 text-xs text-foreground-400">
                <span>{article.publishDate}</span>
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {article.views}
                </span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}